import documents from "./documents.json";
import layout from "./layout.json";
import login from "./login.json";
import validationForm from "./validation_form.json";
import forgotPassword from "./forgot_password.json";
import resetPassword from "./reset_password.json";
import register from "./register.json";
import allotments from "./allotments.json";
import accountManagement from "./account_management.json";
import analyticsPerformance from "./analytics_performance.json";
import ranking from "./ranking.json";
import help from "./help.json";
import marketing from "./marketing.json";
import billing from "./billing.json";
import exportPage from "./export_page.json";
import reviewManagement from "./review_management.json";
import dashboard from "./dashboard.json";
import booking from "./booking.json";
import voucher from "./voucher.json";
import packages from "./package.json";
import button from "./button.json";
import filterPage from "./filter_page.json";
import toast from "./toast.json";
import menu from "./menu.json";
import successDialog from "./success_dialog.json";
import exportHistory from "./export_history.json";
import selectBranch from "./select_branch.json";
import multiBranch from "./multi_branch.json";
import report from "./report.json";
import pricingRules from "./pricing_rules.json";
import error from "./error.json";
import setPassword from "./set_password.json";

export default {
  title: "Portal Partner TH",
  layout,
  login,
  documents,
  validationForm,
  forgotPassword,
  resetPassword,
  register,
  button,
  allotments,
  accountManagement,
  analyticsPerformance,
  ranking,
  help,
  marketing,
  menu,
  billing,
  exportPage,
  reviewManagement,
  dashboard,
  booking,
  package: packages,
  voucher,
  filterPage,
  toast,
  successDialog,
  exportHistory,
  selectBranch,
  multiBranch,
  report,
  pricingRules,
  error,
  setPassword,
};
